// removed by extract-text-webpack-plugin
module.exports = {"Container":"ViewChild__Container__374XO","ViewChild":"ViewChild__ViewChild__Jn4v8","VaccButton":"ViewChild__VaccButton__26Mj9","ViewChildContent":"ViewChild__ViewChildContent__3eeeJ","ViewChildInner":"ViewChild__ViewChildInner__3cVPd","ViewChildInner2":"ViewChild__ViewChildInner2__3mG1W","Btn":"ViewChild__Btn__3ioKC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChildController/ViewChild/ViewChild.css
// module id = 117
// module chunks = 0